import React, { Component, useEffect } from 'react'
import { connect } from 'react-redux'
import InputBase from '@material-ui/core/InputBase';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import swal from 'sweetalert'
import moment from 'moment'
import DialogActions from '@material-ui/core/DialogActions';
import { Grid, Box } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import axios from '../../http-config'
import ReactPaginate from 'react-paginate';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import * as actionsCreators from '../../store/actions/index'
import { withTranslation } from 'react-i18next';
import Clusterbulkupload from '../../Cluster_bulk_uploader.xlsx'
import TablePagination from '@material-ui/core/TablePagination';
import { DialogContent } from '@material-ui/core';
export class ClusterListing extends Component {
    state = {
        anchorEl: null,
        open: false,
        id: '',
        page: 0,
        limit: 10,
        selected: [],
        currentSortId:'',
        sortObj : {
            key: '',
            value: ''
        },
        openPop: false,
        role: '',
        roleOption:[],
            username: "",
            email: "",
            password:"",
        controls: {
            search: {
                value: '',
            }
        },
        isDefaultValue :'',
        tfaIDvalue:'',
        anchorEl_bulk_property             : null,
        placement_property                : '',
        open_bulk_property                : false,
        tfIdValue: '',
        isPasswordShown:false,
        openeditPop: false,
        clusterUser: [],
        editId: '', 
        editUser: '',
        editEmail: '',
        editPass: '',
        editRole: ''
        }
    componentDidMount() {
        axios({
            method: 'get',
            url: `/role`,
            headers: { 'Authorization': `Bearer ${this.props.token}` }
        })
            .then((response) => {
                this.setState({ roleOption: response.data.data.slice(0, 4).filter((i) => i.id !== '4')})
               
            })
        const payload = {
            token: this.props.token,
            page: this.state.page,
            limit: this.state.limit,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            searchQuery: this.state.controls.search.value
        }
        this.props.onFetchClusterHeaders(payload)
        this.props.onFetchClusterData(payload)
        
    }
    handleClickMoreVertIcon = (event, id, isDefaultValue, tfaIDvalue, tfIdValue) => {
        this.setState({ open: !this.state.open, anchorEl: event.currentTarget,  id , isDefaultValue, tfaIDvalue, tfIdValue})
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        this.setState({ page: selectedPage + 1 })
        let payload = {
            token: this.props.token,
            page: selectedPage + 1,
            limit: this.state.limit,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            searchQuery: this.state.controls.search.value
        }
        this.props.onFetchClusterData(payload)
    };

    handleChangePage = (event, newPage) => {
    //    console.log(this.state.page, "PAGE");
        this.setState({page: newPage})
      };
      handleChangeRowsPerPage = (event) => {
        this.setState({limit:parseInt(event.target.value, 10),page:0});
        
      };

    handleClickAwayEdit = () => {
        this.setState({ open: false });
    };
    handleDelete = (Cid, tfaIdvalue, t) => {
        const payload = {
            "tfaId": tfaIdvalue,
            "clusterUlbId":Cid,

        }
        this.props.onDeleteUlbData(payload,t)
    }
    onFileUploadProperty = () => { 
        let props= this.props
        const payload = {
            token : this.props.token
        }
        const formData = new FormData(); 
        formData.append(
            "Clusterbulkupload", 
            this.state.selectedFile, 
            this.state.selectedFile.name 
        )
        this.props.OnbulkCluster(payload,formData,props);
        this.setState({open_bulk_property:false})
    }
    onFileChangeProperty = (event) => {
        this.setState({ selectedFile: event.target.files[0]},()=>{
            this.onFileUploadProperty()
        });   
    }
    handleSort = (e,sortBy) => {
        let sortObj
        if (this.state.sortObj.key === sortBy.accessor) {
            let value = (this.state.sortObj.value === 'desc') ? 'asc' : 'desc';
            sortObj = {
                key : sortBy.accessor,
                value: value
            }
        } 
        else {
            sortObj = {
                key : sortBy.accessor,
                value: 'desc'
         }    
         }
 
        this.setState({ sortObj: sortObj ,currentSortId:sortBy.accessor});
        let payload = {
            token: this.props.token,
            sortName:sortObj.key,
         sortValue : sortObj.value,
         page: this.state.page,
         limit: this.state.limit,
         searchQuery: this.state.controls.search.value
        }

        this.props.onFetchClusterData(payload);
  
      }


      handlePropertySearch = (e) => {
        e.preventDefault()
        let searchVal = this.state.controls.search.value
        if (!!searchVal && searchVal.length >= 2) {
            let payload = {
                token: this.props.token,
                searchQuery:searchVal,
                limit:10,
                page:this.state.page,
                // propertyTypeId: this.state.filterValue,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
              
            }
            this.props.OnSearchClusterName(payload) 
        } else {
         
            swal("Enter atleast 2 characters")
        }
    }
    inputChangedHadler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
            }
        }
        this.setState({ controls: updatedControls });
        if( updatedControls.search.value === ''){
            let payload = {
                token: this.props.token,
                searchQuery:'',
                limit:this.state.limit,
                page:this.state.page,
                // propertyTypeId: this.state.filterValue,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
            }
            this.props.OnSearchClusterName(payload) 
        }
   
    }
    openNewUser = () => {  
        this.setState({openPop: true})
    }
    handleClosePop = () => {
        this.setState({openPop: false})
    }

    handleNewUser = () => { 
            const payload = {
                userName: this.state.username,
                email: this.state.email,
                password: this.state.password,
                roleId: this.state.role,
                ULBId :this.state.id
            }
            let SubmitProp = this.props
            this.props.onAddUserCluster(payload, SubmitProp)  
            this.setState({username: "", password: "", role: "", email: "", openPop: false})
     }
     toggleVisibility=()=>{
        const{isPasswordShown}=this.state
        this.setState({isPasswordShown:!isPasswordShown})
      }
     
     handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
}
    handleClickAwayBulkProperty = () => {
        this.setState({open_bulk_property: false});
    };
    handleClickProperty = (newPlacement) => (event) => {
        this.setState({ anchorEl_bulk_property:event.currentTarget, placement_property:newPlacement, open_bulk_property:!this.state.open_bulk_property});
    };
    handleCloseProperty = (event) => {
        this.setState({open_bulk_property:false})
    };

    // calling pagination funcation page wise
    handleChangePage = (event, newPage) => {
        this.setState({page:newPage})
      };
    // calling pagination funcation row wise
    handleChangeRowsPerPage = (event) => {
        this.setState({limit:parseInt(event.target.value, 10),page:0});
        
      };
    render(){
        const {t, i18n} = this.props
        let headerCluster = !!this.props.ClusterHeaders&&this.props.ClusterHeaders
        const cHeaders = !!headerCluster&& headerCluster.map(header => {
            return (
                <TableCell key={header.header} className={"white-space"}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'start',
                        whiteSpace: 'break-spaces',
                        height: '3em'
                    }}>
{header.header === "Action"? "":
                    <div onClick={(e) =>  this.handleSort(e,header)}>
                        <div>{
                            this.state.currentSortId===header.accessor? this.state.sortObj.value ==='asc'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                        }
                        </div>  
                    </div>}
                        {header.header}
                    </div>
                </TableCell>
            )
        })
    const ListingCluster = !!this.props.ClusterData &&this.props.ClusterData.slice(this.state.page * this.state.limit, this.state.page * this.state.limit + this.state.limit).map((data, index)=>{
    const id = data['clusterUlbId']
    const tfaIDvalue = data['tfaId']
    const isDefaultValue = data["isDeleteAble"]
    const tfIdValue = data["tfId"]

    return (
        <TableRow key={index}
        >
            {!!headerCluster&&headerCluster.map(header => {
                    if (header.accessor == 'actionButton') {
                        return <TableCell key={header.accessor}>
                            <IconButton onClick={(e) => this.handleClickMoreVertIcon(e, id, isDefaultValue, tfaIDvalue, tfIdValue)}
                                aria-label="more"
                                aria-controls="long-menu"
                                aria-haspopup="true">
                                <MoreVertIcon fontSize='small' />
                            </IconButton>
                            <Popper open={this.state.open} anchorEl={this.state.anchorEl}>
                                <ClickAwayListener onClickAway={this.handleClickAwayEdit}>
                                    <Paper style={{ boxShadow: "none", border: "1px solid rgb(61, 171, 53)" }}>
                                        <MenuList>
                                            <Link className='email_link'>
                                                <Link to={`/cluster-management/${ this.state.tfaIDvalue}`} className='email_link'><MenuItem>{t("edit")}</MenuItem></Link>
                                            </Link>
                                            {this.state.isDefaultValue == true?   <MenuItem style={{ color: '#3dab35' }} 
                                            onClick={() => {
                                                swal({
                                                    title: t("ulbDeleteErr1"),
                                                    text: t("ulbDeleteErr2"),
                                                    icon: "warning",
                                                    buttons: {
                                                        cancel: t("ulbDeleteErr4"),
                                                        confirm: t("ulbDeleteErr3")
                                                    }
                                                })
                                                    .then((willDelete) => {
                                                        if (willDelete) {
                                                            this.handleDelete(this.state.id, this.state.tfaIDvalue, t);
                                                        }
                                                    });
                                            }}
                                            >{t("delete")}</MenuItem>:""}
                                            <MenuItem className='email_link' onClick={() => this.openNewUser()} style={{color: '#3dab35'}}>{t("CreateNewUser")}</MenuItem>
                                            <Link to={`./clusterUser/${this.state.id}`} className='email_link'> <MenuItem>{t("viewClusterUser")}</MenuItem></Link>
                                        </MenuList>
                                    </Paper>
                                </ClickAwayListener>
                            </Popper>
                        </TableCell>
                    }
                 
                    else {
                        return <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                        }} key={header.accessor} 
                             className={"white-space"}>
                            {data[header.accessor]}
                              </TableCell>
                    }
                })
            }
        </TableRow>
    )
})

        
        return (
            <div>
            <div className="dashboard_right_content">
                <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                <div className="dashboard_right_content_top">
                    <h5>{t("clusterMng")}</h5>
                    <div className="dashboard_right_content_top_options">
                    <div className="dashboard_right_content_top_search">
                                <Paper component="form">
                                    <IconButton aria-label="menu">
                                        <img src="images/search_icon.svg" />
                                    </IconButton>
                                    <InputBase onChange={(event) => this.inputChangedHadler(event, 'search')} placeholder={t("clusterName")} />
                                    <Button onClick={this.handlePropertySearch} variant="contained" color="primary" type="submit">{t("search")}</Button>
                                </Paper>
                            </div>
                        <Link to='/cluster-management/add/new/' className="email_link" ><Button>{t("addNewCluster")}</Button></Link>

                        <Button className="email_link"
                                ref={this.state.anchorRef}
                                aria-controls={this.state.open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={this.handleClickProperty('bottom')}
                                style={{height:'35px'}}>
                               {t("bulkImportCluster")}
                                {
                                    this.state.open ?   <ArrowDropUpIcon /> : <ArrowDropDownIcon/> 
                                }
                                
                            </Button>
                            <Popper style={{zIndex:"10"}} open={this.state.open_bulk_property} anchorEl={this.state.anchorEl_bulk_property} placement={this.state.placement_property} transition>
                            {({ TransitionProps }) => (
                                    <ClickAwayListener onClickAway={this.handleClickAwayBulkProperty}>
                                <Paper style={{zIndex: 1, border:"1px solid #3dab35"}}>
                                    <MenuList>
                                    <MenuItem onChange={this.onFileChangeProperty}> 
                                        <label style={{ color:'#3dab35',fontSize:'small',align:'left', fontFamily: "'Open Sans', sans-serif"}}> 
                                            <input type="file" style={{display:'none',align:'left'}} /> 
                                            {t("bulkUploadCluster")}
                                        </label> 
                                        </MenuItem> 
                                    <a href={Clusterbulkupload} style={{textDecoration:'none', 
                                                                        color:'#3dab35', 
                                                                        fontSize:'small', 
                                                                        fontFamily: "'Open Sans', sans-serif"}} download> 
                                        <MenuItem onClick={this.handleCloseProperty}>{t("downloadSamp")}</MenuItem>     
                                    </a>
                                    </MenuList>
                                </Paper>
                                </ClickAwayListener>
                            )}
                            </Popper> 
                    </div>
                </div>
            </div>
            {(this.props.loadingCluster == false)? <div id="cover-spin"></div>:''}
            <div className="ulb_listing " >
                <TableContainer component={Paper} style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                    <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
                   
                        <TableHead >
                            <TableRow >
                                {cHeaders}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                       
                            {ListingCluster.length === 0&&this.props.loadingCluster == true ? <TableRow style={{textAlign:'center', fontWeight:'bold', fontSize: '13px', }}>
                                        No Records Found !!</TableRow>:ListingCluster }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            {/* created new page UI*/}
            {
                this.props.totalCount && this.props.totalCount != 0 &&
                <TablePagination
                rowsPerPageOptions={[10,50,100]}
                colSpan={3}
                count={this.props.totalCount}
                component="div"
                rowsPerPage={this.state.limit}
                page={this.state.page}
                SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
                }}
                labelRowsPerPage={t("rowsPerPage")}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
            }
        <Dialog
        maxWidth={'md'}
        fullWidth={true} 
        open={this.state.openPop}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>Create New User </span></DialogTitle>
        <DialogContent>
        <div className="create_ulb_content_outer">
                <div className="create_ulb_content create_ulb_contentPop">
                                
                                    
                                    <Grid container spacing={4}>
                                        <Grid item xs={6}>
                                                <FormControl>
                                                    <label className="required" htmlFor="username">{t("userName")}</label>
                                                    <TextField id="username"
                                                        variant="outlined"
                                                        placeholder= {`${t("enterUser")}`}
                                                        name="username"
                                                        value={this.state.username}
                                                        onChange={(e) => this.handleInputChange(e)} />
                                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.usernameErr}</div>
                                                </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="required" htmlFor="email">{t("email")}</label>
                                                <TextField id="email"
                                                    variant="outlined"
                                                    placeholder= {`${t("enterEmail")}`}
                                                    name="email"
                                                    value={this.state.email}
                                                    onChange={(e) => this.handleInputChange(e)} />
                                                <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.emailErr}</div>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                        <form autocomplete="off">
                                        <FormControl>
                                        <label className={this.state.username ? "required" : ''} htmlFor = "password">{t("userPass")}</label>
                      
                                        <OutlinedInput id = "password" 
                                                        variant="outlined" 
                                                        placeholder= {`${t("enterPass")}`} 
                                                        name="password" 
                                                        value={this.state.password}
                                                        onChange={(e) => this.handleInputChange(e)}
                                                        type={this.state.isPasswordShown ? "text" : "password"}
                                                        endAdornment={this.state.isPasswordShown ?
                                                            (<InputAdornment position="end"><VisibilityOffOutlinedIcon 
                                                            onClick={()=>{this.toggleVisibility()}}
                                                            /></InputAdornment>) :
                                                            (<InputAdornment position="end">
                                                                <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={()=>{this.toggleVisibility()}}
                                                                >
                                                                <img src="images/eye.svg" />
                                                            </IconButton> </InputAdornment> )    
                                                            }
                                                            errortext={this.state.passwordError}    
                                        />
                                     
                                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.passwordErr}</div>
                                            </FormControl>
                                            </form>
                                            </Grid>
                                            <Grid item xs={6}>
                                              
                                                <FormControl fullWidth>
                                                    <label className="required" htmlFor="role" align="left">{t("role")}</label>
                                                    <Select value={this.state.role} onChange={(e) => this.handleInputChange(e)} name="role">
                                                                {
                                                                this.state.roleOption                          
                                                                .map((option) =>  
                                                                    <MenuItem value={option.roleId}>{option.name}</MenuItem> 
                                                                )}
                                                    </Select> 
                                                         
                                                </FormControl>
                                              
                                            </Grid>      
                                    </Grid>
                                    
            {this.state.openPop === true? 
        <Grid container spacing={1}>
        <Grid item xs={12}>
         <div className="create_ulb_buttons" style={{marginBottom:'10px'}}>
                    <Button className='login_submit' variant='contained' color='primary' onClick={this.handleClosePop}>Cancel</Button>
                    <Button className="login_submit" variant="contained" color="primary" onClick={this.handleNewUser}>{this.state.roleId != "" ? "Save": "SaveChange"}</Button>
         </div>
            </Grid>
        </Grid>:""}
        
        </div>
        </div>
        </DialogContent>
        </Dialog>
        </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        ClusterHeaders: state.ClusterrReducer.ClusterHeaders.concat({header: "Action", accessor: "actionButton", sortable: "false", filter: "false"}),
        ClusterData: state.ClusterLIstingReducer.clusterData,
        totalCount: state.ClusterLIstingReducer.totalCount,
        loadingCluster: state.ClusterLIstingReducer.loading
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({

        onFetchClusterHeaders: (payload) => dispatch(actionsCreators.fetchClusterHeaders(payload)),
        onFetchClusterData: (payload) => dispatch(actionsCreators.fetchClusterData(payload)),
        onDeleteUlbData: (payload, t) => dispatch(actionsCreators.deleteClusterUlbData(payload, t)),
        onAddUserCluster: (payload, SubmitProp) => dispatch(actionsCreators.addUserCluster(payload, SubmitProp)),
        onEditUserCluster: (payload, SubmitProp) => dispatch(actionsCreators.editUserCluster(payload, SubmitProp)),
        OnSearchClusterName: (payload) => dispatch(actionsCreators.searchClusterName(payload)),
        OnbulkCluster   : (payload,formData,props) => dispatch(actionsCreators.bulkCluster(payload,formData,props)),
    })
}

export default connect(mapStateToProps, mapDispatchToProps) (withTranslation()(ClusterListing));
